var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.talentLoading,
          expression: "talentLoading",
        },
      ],
      staticStyle: { "min-height": "200px" },
    },
    [
      _vm.achData && _vm.achData.length && !_vm.talentLoading
        ? _c(
            "div",
            _vm._l(_vm.achData, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "person-item",
                  on: {
                    click: function ($event) {
                      return _vm.toDetail(item.id)
                    },
                  },
                },
                [
                  _c("div", { staticStyle: { "margin-left": "8px" } }, [
                    _c("div", { staticClass: "person-name" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "item-left flex-wrap",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c("label", { staticClass: "no-wrap" }, [
                          _vm._v("发明人："),
                        ]),
                        _vm._l(
                          item.authors && item.authors.length > 3
                            ? item.authors.slice(0, 3)
                            : item.authors,
                          function (author, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticClass: "item-right",
                                staticStyle: {
                                  "margin-right": "9px",
                                  "flex-shrink": "0",
                                },
                                attrs: { title: author.scholarName },
                              },
                              [
                                _c(
                                  "el-avatar",
                                  {
                                    attrs: {
                                      fit: "cover",
                                      size: 14,
                                      src: author.avatarUrl,
                                    },
                                    on: { error: _vm.errorHandler },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" " + _vm._s(author.scholarName) + " "),
                              ],
                              1
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    false
                      ? _c("div", { staticClass: "item-left ellipsis" }, [
                          _c("label", [_vm._v("申请人：")]),
                          _c("span", { staticClass: "item-right ellipsis" }, [
                            _vm._v(_vm._s(item.applicantName || "-")),
                          ]),
                        ])
                      : _vm._e(),
                    false
                      ? _c("div", { staticClass: "item-left" }, [
                          _c("label", [_vm._v("申请时间：")]),
                          _c("span", { staticClass: "item-right" }, [
                            _vm._v(
                              _vm._s(
                                item.applicationDate
                                  ? _vm.formatToDate(item.applicationDate)
                                  : "-"
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "item-left" }, [
                      _c("label", [_vm._v("专利类型：")]),
                      _c(
                        "span",
                        {
                          staticClass: "item-right",
                          staticStyle: { "margin-right": "10px" },
                        },
                        [_vm._v(_vm._s(item.patentType || "-"))]
                      ),
                    ]),
                    _c("div", { staticClass: "item-left" }, [
                      _c("label", [_vm._v("公开日期：")]),
                      _c("span", { staticClass: "item-right" }, [
                        _vm._v(
                          _vm._s(
                            item.publicationDate
                              ? _vm.formatToDate(item.publicationDate)
                              : "-"
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "item-left" }, [
                      _c("label", [_vm._v("公开(公告)号：")]),
                      _c(
                        "span",
                        {
                          staticClass: "item-right",
                          staticStyle: { "margin-right": "10px" },
                        },
                        [_vm._v(_vm._s(item.publicationNum || "-"))]
                      ),
                    ]),
                    false
                      ? _c("div", { staticClass: "item-left" }, [
                          _c("label", [_vm._v("申请号：")]),
                          _c("span", { staticClass: "item-right" }, [
                            _vm._v(_vm._s(item.applicationNum || "-")),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            0
          )
        : _c("div", [_c("el-empty")], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }